<template>
  <section class="publication-table team-table py2 sans border-top mx-auto">
    <h3 class="sm-hide md-hide lg-hide mb3 red">Publications</h3>
    <div class="row clearfix mxn2">
      <div class="col xs-hide sm-col-4 px2">Publications</div>
      <div class="col col-12 sm-col-8 px2">
        <div v-for="(item, index) in content"
          class="hover-red row clearfix mb2" :key="index">
          <div class="col col-12 relative">
            <router-link :to="{ name: 'Publications', hash: `#${item.post_name}` }">
              <em>{{ item.post_title || item.title.rendered }}</em> {{ item.publication_date }}
              <div v-if="showDescription" v-html="item.description"></div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {

  name: 'PublicationTable',

  data () {
    return {

    }
  },

  props: ['content', 'showDescription']
}
</script>

<style lang="css" scoped>
  .publication-table {
    max-width: var(--max-width-med);
    /*font-size: var(--font-size-reader);*/
    line-height: var(--line-height-reader);
  }
</style>
